import React from "react";
import { Input as AntInput } from "antd";
import "../styles/eventFormStyles.css";
import ImageUploadButton from "../../../../website/ImageUploaderButton";
import useContentFormParams from "../hooks/useContentFormParams";

export const DetailsAndImageSection = ({
  details,
  imageFile,
  onDetailsChange,
  onImageSave,
  isAnnouncementType,
  editConfiguration,
  setEditConfiguration,
}) => {
  const { formMode } = useContentFormParams();
  return (
    <>
      <div className="event-form-field-wrapper">
        <div className="event-form-label">Details</div>
        <AntInput.TextArea
          value={details}
          onChange={onDetailsChange}
          placeholder={
            isAnnouncementType
              ? "Write an article for the news.."
              : "Join us for a season kickoff party at Fado!"
          }
          rows={isAnnouncementType ? 13 : 3}
          disabled={formMode === "view"}
          style={{ fontSize: "14px" }}
        />
      </div>

      <div className="event-form-field-wrapper">
        <div className="event-form-label">Image</div>
        <ImageUploadButton
          text="Upload"
          images={imageFile ? [imageFile] : []}
          onSave={(images) => {
            if (formMode === "edit" && !editConfiguration.imageChanged) {
              setEditConfiguration((prev) => ({
                ...prev,
                imageChanged: true,
              }));
            }
            onImageSave(images[0]);
          }}
        />
        <div className="event-form-help-text">
          If no image uploaded, default image will appear. Image dimensions are
          800x450 (16:9 ratio)
        </div>
      </div>
    </>
  );
};
